"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.boxSizingSizesNegatives = exports.boxSizingSizes = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sizeMap = {
  none: 0,
  mini: 1,
  small: 1.5,
  medium: 2,
  large: 2.5,
  xl: 3,
  xxl: 4,
  xxxl: 8,
  nMini: -1,
  nSmall: -1.5,
  nMedium: -2,
  nLarge: -2.5,
  nXl: -3,
  nXxl: -4,
  nXxxl: -8
};

var BoxSizing = function BoxSizing(_ref) {
  var pt = _ref.pt,
      pb = _ref.pb,
      pl = _ref.pl,
      pr = _ref.pr,
      mt = _ref.mt,
      mb = _ref.mb,
      ml = _ref.ml,
      mr = _ref.mr,
      maxWidth = _ref.maxWidth,
      width = _ref.width,
      children = _ref.children;
  return /*#__PURE__*/_react.default.createElement(_core.Box, {
    pt: sizeMap[pt],
    pb: sizeMap[pb],
    pl: sizeMap[pl],
    pr: sizeMap[pr],
    mt: sizeMap[mt],
    mb: sizeMap[mb],
    ml: sizeMap[ml],
    mr: sizeMap[mr],
    maxWidth: maxWidth,
    width: width
  }, children);
};

BoxSizing.propTypes = {
  /** Padding Top */
  pt: _propTypes.default.oneOf(["none", "mini", "small", "medium", "large", "xl", "xxl"]),

  /** Padding Bottom */
  pb: _propTypes.default.oneOf(["none", "mini", "small", "medium", "large", "xl", "xxl"]),

  /** Padding Left */
  pl: _propTypes.default.oneOf(["none", "mini", "small", "medium", "large", "xl", "xxl"]),

  /** Padding Right */
  pr: _propTypes.default.oneOf(["none", "mini", "small", "medium", "large", "xl", "xxl"]),

  /** Margin Top */
  mt: _propTypes.default.oneOf(["none", "mini", "small", "medium", "large", "xl", "xxl", "nMini", "nSmall", "nMedium", "nLarge", "nXl", "nXxl"]),

  /** Margin Bottom */
  mb: _propTypes.default.oneOf(["none", "mini", "small", "medium", "large", "xl", "xxl", "nMini", "nSmall", "nMedium", "nLarge", "nXl", "nXxl"]),

  /** Margin Left */
  ml: _propTypes.default.oneOf(["none", "mini", "small", "medium", "large", "xl", "xxl", "nMini", "nSmall", "nMedium", "nLarge", "nXl", "nXxl"]),

  /** Margin Right */
  mr: _propTypes.default.oneOf(["none", "mini", "small", "medium", "large", "xl", "xxl", "nMini", "nSmall", "nMedium", "nLarge", "nXl", "nXxl"]),

  /** The max width of the element */
  maxWidth: _propTypes.default.string,

  /** The width of the element */
  width: _propTypes.default.string,
  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.node])
};
BoxSizing.defaultProps = {
  pt: "none",
  pb: "none",
  pl: "none",
  pr: "none",
  mt: "none",
  mb: "none",
  ml: "none",
  mr: "none",
  maxWidth: "auto",
  width: "auto",
  children: null
};
var boxSizingSizes = ["none", "mini", "small", "medium", "large", "xl", "xxl"];
exports.boxSizingSizes = boxSizingSizes;
var boxSizingSizesNegatives = ["none", "mini", "small", "medium", "large", "xl", "xxl", "nMini", "nSmall", "nMedium", "nLarge", "nXl", "nXxl"];
exports.boxSizingSizesNegatives = boxSizingSizesNegatives;
var _default = BoxSizing;
exports.default = _default;